export default {
  FaceBookLogin: 'Facebook으로 로그인',
  GoogleBookLogin: 'Google로 로그인',
  Agree: '동의합니다',
  AgreeTermofService: 'Gameloop 서비스 약관에',
  AgreePrivacyPolicy: 'Gameloop 개인 정보 보호 정책에',
  InformationRequired: '필요한 정보',
  proceed: '계속하려면 추가 정보가 필요합니다',
  DateOfBirth: '생년월일',
  CountryRegion: '국가 / 지역',
  Confim: '확인',
  PleaseAgreeTerms: '약관에 동의해 주십시오',
  LogFailed: '로그인 실패',
  LogCancelled: '로그인 취소됨',
  EmailAddress: 'E-mail Address',
  MailVerification: 'E-Mail Verification',
  VerifiedMail: 'Your E-mail needs to be verified to receive the product',
  EnterVcode: 'Please enter the verification code you received',
  EmailError: 'E-mail input format incorrect',
  VcodeError: 'Verification code input format incorrect',
  EvcodeError: 'E-mail verification code input format incorrect',
  EmailIError: 'E-mail incorrect',
  VcodeIError: 'Password incorrect',
  EvcodeIError: 'E-mail verification code incorrect',
  CheckRequiredField: 'Please check the required field',
  HoundSuccess: 'Successfully bound',
  SendCode: 'Send Code',
  SendSuccess: 'Verification code sent',
  CanNotReceive: 'Can\'t receive it? Get some',
  Help: 'Help',
  NotRobot: 'I\'m not a robot',
  EmailVCode: 'E-mail Verification Code',
  Confirm: 'Confirm',
  UnderAgeRequirement: '귀하의 연령이 Gameloop의 조건에 맞지 않습니다. 로그인할 수 없습니다.',
};
